import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import request from '../../utils/request';
import { sortedObjects } from '../../utils/utils';
import Label from './common/label';

const MultiChannel = ({ labels, errors, touched }) => {
  const [channelsList, setChannelsList] = useState([]);

  useEffect(() => {
    request.get('/channels').then(({ data: { channels } }) => {
      setChannelsList(channels);
    });
  }, []);

  return (
    <>
      <Label labelName={labels.CHANNEL_YOU_SUPPORT} />
      <div
        style={{ position: 'relative', width: '100%' }}
        className={`frg-select-container color-light input-container ${
          errors.multiChannels && touched.multiChannels ? 'error' : ''
        }`}
      >
        <div role="group" aria-labelledby="checkbox-group">
          {channelsList &&
            channelsList.length > 0 &&
            sortedObjects(channelsList, 'description').map(channel => {
              return (
                <div>
                  <Field
                    type="checkbox"
                    name="multiChannels"
                    value={channel.name}
                  />
                  <span style={{ marginLeft: '0.5rem' }}>
                    {channel.description}
                  </span>
                </div>
              );
            })}
        </div>
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.multiChannels}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

MultiChannel.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default MultiChannel;
